<template>
  <l-marker :lat-lng="coords" :icon="getMarkerIcon('#cc99ff')">
    <l-popup>
      <div class="t-marker-tooltip" @click="redirectToLesson">
        <slot v-if="image" name="image" :src="image">
          <img class="t-marker-tooltip__image" :src="image" />
        </slot>
        <span class="t-marker-tooltip__title">
          {{ title }}
        </span>
        <div class="t-marker-tooltip__description" v-html="description" />
      </div>
    </l-popup>
  </l-marker>
</template>

<script>
import { LMarker, LPopup } from 'vue2-leaflet'
import { divIcon } from 'leaflet'

export default {
  name: 'MarkerTootip',
  components: {
    LMarker,
    LPopup
  },
  props: {
    theme_id: String,
    step_id: String,
    lesson_id: String,
    coords: Array,
    image: String,
    title: String,
    description: String,
    icon: Object
  },
  methods: {
    getMarkerIcon(color) {
      return divIcon({
        className: `markerTootip`,
        iconSize: [25, 80],
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 34.892337" height="40" width="25">
    <g transform="translate(-814.59595,-274.38623)">
      <g transform="matrix(1.1855854,0,0,1.1855854,-151.17715,-57.3976)">
        <path d="m 817.11249,282.97118 c -1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867 0.0639,3.84476 1.79693,5.3002 4.56836,10.59179 0.99832,2.32851 2.04027,4.79237 3.03125,8.87305 0.13772,0.60193 0.27203,1.16104 0.33416,1.20948 0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455 0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109 2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918 0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062 -1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655 -2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162 z" style="fill:${color};stroke:lightgray;"/>
        <circle r="3.0355" cy="288.25278" cx="823.03064" id="path3049" style="display:inline;fill:white;"/>
      </g>
    </g>
  </svg>`
      })
    },
    redirectToLesson() {
      this.$router.push({
        name: 'lesson',
        params: {
          themeId: this.theme_id,
          lessonStepId: this.step_id,
          lessonId: this.lesson_id
        }
      })
    }
  }
}
</script>

<style lang="scss">
@mixin text-no-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.leaflet-popup-content-wrapper {
  overflow: hidden;
  padding: 0;

  .leaflet-popup-content {
    margin: 0;
    width: 300px !important;
  }
}

.t-marker-tooltip {
  height: 100%;
  width: 100%;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  text-align: center;
  cursor: pointer;

  &__image {
    height: 80px;
    width: 100%;
    object-fit: cover;
    margin-bottom: 5px;
  }

  &__title {
    width: 100%;
    font-weight: bold;
    padding: 0 5px;
    @include text-no-wrap;
  }

  &__description {
    width: 100%;

    p {
      display: none;

      &:first-child {
        display: inline-block;
        padding: 0 5px;
        margin: 5px 0;
        width: 100%;
        max-height: 35px;
        @include text-no-wrap;
      }
    }
  }

  &__step-number {
    position: absolute;
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 5px;
    left: 5px;
    background: #d4d7fb;
    color: #5357c1;
    border-radius: 50px;
  }
}
</style>
